export default {
    methods: {
        getPaymentDate() {
            const lastIndex = this.info.schedule.length - 1;
            const lastElement = this.info.schedule[lastIndex];
            const date = lastElement.date.split('|')[1].trim();
            const currentDate = new Date(date);
            currentDate.setDate(currentDate.getDate() + 12);
            const dayOfMonth = currentDate.getDate();
            const month = currentDate.toLocaleString('default', { month: 'long' });
            this.paymentDate = `${dayOfMonth} ${month}, ${currentDate.getFullYear()}`;
        },
        calculateTotal(week) {
            let days; {
                if (week === 'first') {
                    days = this.info.schedule.slice(0, 7);
                    this.firstWeekTotal = days.map(d => d.result || 0).reduce((accumulator, currentValue) => {
                        return accumulator + currentValue;
                    }, 0)
                } else {
                    days = this.info.schedule.slice(7, 14);
                    this.secondWeekTotal = days.map(d => d.result || 0).reduce((accumulator, currentValue) => {
                        return accumulator + currentValue;
                    }, 0)
                }
            }
        },
        calculateRegularAndOvertime() {
            const calculateWeek = (weekTotal) => {
                if (weekTotal <= 144000000) {
                    return { regular: weekTotal, overtime: 0 };
                } else {
                    return { regular: 144000000, overtime: weekTotal - 144000000 };
                }
            };

            const firstWeek = calculateWeek(this.firstWeekTotal);
            const secondWeek = calculateWeek(this.secondWeekTotal);

            this.firstWeekRegular = firstWeek.regular;
            this.firstWeekOvertime = firstWeek.overtime;
            this.secondWeekRegular = secondWeek.regular;
            this.secondWeekOvertime = secondWeek.overtime;

            const sum = this.firstWeekTotal + this.secondWeekTotal;

            if (sum <= 288000000) {
                this.totalRegularHours = sum;
                this.totalOvertime = null;
            } else {
                this.totalRegularHours = 288000000;
                this.totalOvertime = sum - 288000000;
            }
        },
    },
}


